import Component from './privacy'

export default Component